import {ChangeDetectionStrategy, Component} from "@angular/core";
import {MatDialog, MatDialogActions, MatDialogClose, MatDialogConfig, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {MatDivider} from "@angular/material/divider";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'hjelp-dialog',
    templateUrl: 'hjelp-dialog.html',
    styleUrl: 'hjelp-dialog.scss',
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
        MatButton,
        MatDivider,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HjelpDialogKomponent {

    static vis(dialog: MatDialog): MatDialogRef<HjelpDialogKomponent> {
        return dialog.open(HjelpDialogKomponent, matDialogKonfig());
    }

    readonly hjelpesenterUrl = 'https://support.styreplan.no/no/';
    readonly epost = 'hjelp@styreplan.no';
    readonly telefon = '40 60 44 75';
    readonly telefonLenke = 'tel:+4740604475';
}

function matDialogKonfig(): MatDialogConfig {
    return {
        panelClass: 'hjelpDialogPanel',
        ariaLabelledBy: 'hjelp-dialog-tittel',
        width: '540px',
        maxWidth: '90vw'
    };
}
